import { Component, h } from 'preact'
import {
  buildQuestionList,
  Button,
  choice,
  CopyButton,
  IconButton,
  Question,
} from 'ac-patterns'
import contacts from './contacts'

const sizeFields = [
  {
    name: 'size',
    label: 'Size (in pixels)',
    type: 'decimal',
    onInput: true,
    maxLenBefore: 4,
    maxLenAfter: 0,
  },
]

const fields = [
  {
    name: 'data',
    label: 'The url/data to embed',
    onInput: true,
  },
  {
    name: 'format',
    label: 'Image format',
    choices: [
      choice('png', 'png', sizeFields),
      choice('jpg', 'jpg', sizeFields),
      choice('svg'),
    ],
  },
  {
    name: 'logo',
    label: 'Include Logo',
    choices: [choice('Yes', true), choice('No', false)],
  },
]

// const getVCardUrl = id => `http://localhost:3002/vcard/${id}`
const getVCardUrl = id => `https://api.xchart.com/vcard/${id}`
const fetchVCard = id => fetch(getVCardUrl(id)).then(res => res.text())

export class QrApp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: 'https://xchart.com',
      format: 'svg',
      size: '400',
      logo: true,
      vcards: [],
    }
  }

  componentDidMount() {
    Promise.all(contacts.map(({ apiId }) => fetchVCard(apiId))).then(
      contactResults => {
        this.setState({ vcards: contactResults })
      }
    )
  }

  render() {
    const { data, size, format, logo, vcards } = this.state
    const processedFields = buildQuestionList(fields, this.state, {})
    let url

    if (!data) {
      url = null
    }
    if (data) {
      url = `https://api.xchart.com/fns/qr?data=${encodeURIComponent(data)}`
      if (format !== 'svg') {
        url += `&format=${format}`
        url += size ? `&size=${size}` : ''
      }
      if (!logo) {
        url += `&addLogo=false`
      }
    }

    return (
      <div>
        <div class='bg-white dark-blue flex justify-center'>
          <div class='w-100 mw7 ph2 tl'>
            <h2 class='f2'>QR Generator</h2>
            <div>
              {processedFields.map(item => (
                <Question
                  key={item.name}
                  updateValue={val => {
                    this.setState({ [item.name]: val })
                  }}
                  item={item}
                />
              ))}
            </div>
            {url && (
              <div>
                <span>
                  <div className='pv2'>URL: {url}</div>
                  <div className='flex items-center'>
                    <Button
                      className='mr2 nowrap'
                      onClick={e => {
                        e.preventDefault()
                        e.stopImmediatePropagation()
                        location = url + '&download=true'
                      }}
                      type='button'
                    >
                      Download Image
                    </Button>
                    <CopyButton
                      buttonText='Copy URL To Clipboard'
                      className='nowrap'
                      text={url}
                    />
                  </div>
                </span>
                <div className='mv3'>
                  <h3>Preview:</h3>
                  <img
                    className='shadow-2'
                    src={url}
                    height={size || 200}
                    width={size || 200}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div class='bg-white dark-blue flex justify-center'>
          <div class='w-100 mw7 ph2 tl'>
            <h2 class='f2'>Contacts</h2>
            <p>Scannable Contact Cards</p>
            <div className='flex items-center flex-wrap justify-between gap3'>
              {contacts.map(({ apiId, details }, index) => {
                const vcard = vcards[index]
                return (
                  <div key={apiId}>
                    <h3 className='mb3'>
                      {details.name ||
                        `${details.firstName} ${details.lastName}`}
                    </h3>
                    <div className='mb3'>
                      <a href={getVCardUrl(apiId)} download>
                        <IconButton icon='download'>
                          Download Contact Card
                        </IconButton>
                      </a>
                    </div>

                    {vcard && (
                      <img
                        src={`https://api.xchart.com/fns/qr?data=${encodeURIComponent(
                          vcard
                        )}`}
                        width='350'
                      />
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
